import { environmentHttpClient } from "client/Api/httpClient";
import { SecretValue } from "client/Api/Apps/common";

export type VilansKickConnectionListItemModel = {
	id: number;
	name: string;
};

export type VilansKickConnectionModel = {
	id: number;
	name: string;
};

export type VilansKickConnectionSaveModel = {
	name: string;
	apiKey: SecretValue;
};

export function list(signal?: AbortSignal): Promise<VilansKickConnectionListItemModel[]> {
	return environmentHttpClient.get<VilansKickConnectionListItemModel[]>(
		"UiApi/VilansKickConfiguration/List",
		null,
		{ signal }
	);
}

export function get(id: number, signal?: AbortSignal): Promise<VilansKickConnectionModel> {
	return environmentHttpClient.get<VilansKickConnectionModel>(
		`UiApi/VilansKickConfiguration/${id}`,
		null,
		{ signal }
	);
}

export function create(model: VilansKickConnectionSaveModel): Promise<{id: number;}> {
	return environmentHttpClient.post<{id: number;}>("UiApi/VilansKickConfiguration", model);
}

export function update(id: number, model: VilansKickConnectionSaveModel): Promise<void> {
	return environmentHttpClient.put<void>(`UiApi/VilansKickConfiguration/${id}`, model);
}

export function deleteMultiple(ids: number[]): Promise<void> {
	return environmentHttpClient.delete<void>("UiApi/VilansKickConfiguration", ids);
}
